import { useQuery } from 'react-query';
import api, { QueryConfig } from '@shared/api';

type SlackChannel = { channelId: string; channelName: string };

type ChannelsResposne = {
  data: SlackChannel[];
};

const getSlackChannels = (organizationId: string) =>
  api.get(`/slack/channels?organizationId=${organizationId}`);

export function useSlackNotificationChannels(
  organizationId: string,
  config: QueryConfig<ChannelsResposne>
) {
  return useQuery(
    ['alert-slack-channels', { organizationId }],
    () => getSlackChannels(organizationId),
    {
      ...config,
      retry: false
    }
  );
}
